import { observeWebVitals } from '@liquid-spirit/observability';

// Adapt only the collector's scalar contract; raw entries and attribution never
// reach local storage, the upload queue, or the development diagnostic.
const reportWebVitals = (onPerfEntry, { onReport } = {}) => {
  if (typeof onPerfEntry !== 'function') return () => {};
  return observeWebVitals({
    record: (sample) => onPerfEntry({
      name: sample.metric.toUpperCase(),
      value: sample.value,
      ...sample.metadata,
    }),
    onReport,
  });
};

export const logIfFCPAbove500 = ({ name, value }) => {
  if (import.meta.env.DEV && name === 'FCP' && value > 500) {
    console.warn(`First Contentful Paint is above 500ms: ${value}ms. React DOM loading is slow.`);
  }
};

export default reportWebVitals;
